// 9fbef606107a605d69c0edbcd8029e5d

const AIAssistantLabels = {
  global: {
    helpCenter: {
      lbl_ai_heading_text:
        'Need help ? Ask a question to our expert chatbot for instant assistance',
      lbl_ai_user_notation: 'You',
      lbl_ai_notation: 'AI Chatbot',
      lbl_ai_help_text: 'How can we Help ?',
    },
  },
};

export default AIAssistantLabels;
